module.exports = __webpack_public_path__ + "themify.e23a7dcaefbde4e74e26.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Wilson/I4 Soluciones/Proyecto Web QA/proyecto-web-clientes-atica-agosto/node_modules/ti-icons/fonts/themify.ttf
// module id = ../../../../ti-icons/fonts/themify.ttf
// module chunks = styles